import { z } from 'zod'

import { typesenseConfigSchema } from '@/publish'
import { entitySchema, nanoidSchema } from '@/utility'

export const subpathSchema = z
  .object({
    subpath: z.string(),
    projectUid: z.string(),
    typesenseConfig: typesenseConfigSchema,
  })
  .meta({ id: 'subpath' })

export type Subpath = z.infer<typeof subpathSchema>

export const siteDeploySchema = entitySchema
  .extend({
    domain: z.string(),
    teamUid: nanoidSchema,
    projectUid: nanoidSchema,
    subpaths: subpathSchema.array().default([]),
  })
  .meta({ id: 'site-deploy' })

export type SiteDeploy = z.infer<typeof siteDeploySchema>
